<p-card class="p-card container">
  <h3 i18n>Relevé de commission et accès Humania</h3>

  <p i18n>Cliquez sur le bouton ci-dessous afin de consulter vos relevés de commission.</p>

  <p-button
    (onClick)="openHumaniaLink()"
    i18n-label
    label="Consulter mes relevés de commission"
    icon="pi pi-external-link"
    iconPos="right"></p-button>
</p-card>
